import Vue from 'vue'
import locale from 'element-ui/lib/locale'      // elementUI的国际化
import VueI18n from 'vue-i18n'
import messages from './langs'

Vue.use(VueI18n)
const i18n = new VueI18n({
  // 初始化语言：
  // - 国外构建（BUILD_REGION=intl）：强制英文，配合 LANG_LOCKED 在运行时保持不可切换
  // - 国内构建：保持中文作为默认，后续可由 App 根据浏览器语言或缓存调整
  locale: process.env.BUILD_REGION === 'intl' ? 'en' : 'zh',
  messages
})
locale.i18n((key, value) => i18n.t(key, value)) // elementui多语言切换

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js